import React from 'react'
import { Drawer } from '@material-ui/core'
import clsx from 'clsx'

const SectionsDrawer = ({ open, classes, children }) => (
  <Drawer
    variant="permanent"
    className={clsx(classes.drawer, {
      [classes.drawerOpen]: open,
      [classes.drawerClose]: !open,
    })}
    classes={{
      paper: clsx({
        [classes.drawerOpenPaper]: open,
        [classes.drawerClosePaper]: !open,
      }),
    }}
  >
    {children}
  </Drawer>
)

export default SectionsDrawer
